<template>
    <div ref="business_block">
        <div class="row" v-if="!is_reviewing">
            <div class="col-md-12 col-12" >
                <div class="panel-sub-heading headingLarge">
                    <span class="h5 markedBottom bold">{{ lang('equipment_and_online_selection') }}</span>
                </div>
            </div>
        </div>
        <div v-if="objectIsNotEmpty(quote.equipment_offer) || objectIsNotEmpty(quote.online_offer)" class="row" id="equipment">
            <div class="col-lg-6 col-md-12 col-12">
                <np-entry
                    :label="lang('package')"
                    mode="inline"
                    :model-value="criteria.package_name">
                </np-entry>
            </div>
            <div class="col-12">
                <div class="row" v-if="showSection('equipment_offerings')">
                    <div class="col-lg-6 col-md-12 col-12">
                        <np-entry
                                  :label="lang('equipment_offering')"
                                  :formatter="formatEquipmentOffering"
                                  mode="inline"
                                  v-show="equipment_offerings.length > 1"
                                  :model-value="quote.equipment_offer.equipment_offering_external_id">
                        </np-entry>
                    </div>
                    <div v-if="equipment_is_loading" class="col-12">
                        <np-skeleton :type="'equipment'"></np-skeleton>
                    </div>
                    <div class="col-12"  v-else>
                        <div class="" v-if="hasSelectedTerminalEquipmentList || hasSelectedBundlePackage" >
                            <div class="">
                                <div class="row">
                                    <div class="col-12" ref="agreement_length"
                                         v-if="!!equipment_offer.equipment_offering_external_id">
                                        <div id="agreement-lengths-block" class="row">
                                            <div class="col-12">
                                                <div class="panel-sub-heading headingSmall">
                                                    <span class="markedBottom">{{lang('agreement_type')}}</span>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-sm-12 col-12"
                                                 v-if="equipment_offer.acquiring_only === '1'">
                                                <np-radios
                                                    :id="'acquiring_only'"
                                                    :aria-label="lang('acquiring_only')"
                                                    :hide-label="true"
                                                    :name="'acquiring_only'"
                                                    :mode="'co-join'"
                                                    :required="true"
                                                    :disabled="true"
                                                    :options="acquiringOnlyParam"
                                                    :model-value="'1'">
                                                </np-radios>
                                            </div>
                                            <div class="col-lg-6 col-sm-12 col-12" v-if="leaseAgreementParam.length > 0">
                                                <np-radios
                                                    :id="'agreement_length'"
                                                    :label="lang('rental_agreement')"
                                                    :name="'agreement_length'"
                                                    :mode="'co-join'"
                                                    :required="true"
                                                    @input="filterByAgreementLength"
                                                    :disabled="true"
                                                    :options="leaseAgreementParam"
                                                    v-model="quote.agreement_length">
                                                </np-radios>
                                            </div>
                                            <div class="col-lg-6 col-sm-12 col-12" v-if="purchaseAgreementParam.length > 0">
                                                <np-radios
                                                    ref=""
                                                    :id="'purchase_agreement_length'"
                                                    :label="lang('purchase')"
                                                    :name="'purchase_agreement_length'"
                                                    :mode="'co-join'"
                                                    :required="true"
                                                    :options="purchaseAgreementParam"
                                                    :disabled="true"
                                                    @input="filterByAgreementLength"
                                                    v-model="quote.purchase_agreement_length">
                                                </np-radios>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div>
                                            <div id="accordionNine" v-if="hasTalechServices">
                                                <div id="talech_service" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(talech_service_block)"
                                                         :id="`heading_talech_service`" data-bs-toggle="collapse" :data-bs-target="`#collapse_talech_service`"
                                                         aria-expanded="true" :aria-controls="`collapse_talech_service`">
                                                        <h5 class="mb-0">
                                                            <span v-if="talech_service_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('talech_services')}}</span>
                                                            <span class="badge badge-info" v-if="numberSelectedTalechService > 0"> {{numberSelectedTalechService}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div v-if="talech_service_block.is_open" data-parent="#accordionNine" id="collapse_talech_service" :aria-labelledby="`heading_talech_service`" class="collapse card-body show">
                                                        <template  v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                            <div class="col-12"  v-if="isTalechService(bundle_item)"  :key="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`">
                                                                <talech-service
                                                                    :bundle_item="bundle_item"
                                                                    :bundle_item_key="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                    :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                    :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`"
                                                                    :is-view="true"
                                                                />
                                                            </div>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionSeven" v-if="hasSpecialOffers">
                                                <div id="special_offer" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(special_offer_block)"
                                                         :id="`heading_special_offer`" data-bs-toggle="collapse" :data-bs-target="`#collapse_special_offer`"
                                                         aria-expanded="true" :aria-controls="`collapse_special_offer`">
                                                        <h5 class="mb-0">
                                                            <span v-if="special_offer_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('special_offers')}}</span>
                                                            <span class="badge badge-info" v-if="numberSelectedSpecialOffers > 0"> {{numberSelectedSpecialOffers}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionSeven" id="collapse_special_offer" :aria-labelledby="`heading_special_offer`" class="collapse card-body show">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-12" v-if="isSpecialOfferService(bundle_item) && bundle_item.display">
                                                                    <equipment-services :bundle_item="bundle_item"
                                                                                        :is-view="true"
                                                                                        :is-standalone="false"
                                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-services>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="accordionEight" v-if="hasThirdPartyEquipments">
                                                <div id="third_party_equipment" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(third_party_equipment_block)"
                                                         :id="`heading_third_party_equipment`" data-bs-toggle="collapse" :data-bs-target="`#collapse_third_party_equipment`"
                                                         aria-expanded="true" :aria-controls="`collapse_third_party_equipment`">
                                                        <h5 class="mb-0">
                                                            <span v-if="third_party_equipment_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('third_party_equipments')}}</span>
                                                            <span class="badge badge-info" v-if="numberSelectedThirdPartyEquipments > 0"> {{numberSelectedThirdPartyEquipments}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionEight" id="collapse_third_party_equipment" :aria-labelledby="`heading_third_party_equipment`" class="collapse card-body show">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-lg-6 col-md-6 col-sm-12 col-12" v-if="isThirdPartyEquipmentService(bundle_item) && bundle_item.display">
                                                                    <third-party-equipment
                                                                        :bundle_item="bundle_item"
                                                                        :is-standalone="false"
                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`"
                                                                        :isView="true"
                                                                    >
                                                                    </third-party-equipment>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="accordionOne" v-if="hasSelectedTerminals || hasSelectedBundlePackage">
                                                <div id="terminals" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(terminals_block)"
                                                         :id="`heading_terminal`" data-bs-toggle="collapse" :data-bs-target="`#collapse_terminal`"
                                                         aria-expanded="true" :aria-controls="`collapse_terminal`">
                                                        <h5 class="mb-0">
                                                            <span v-if="terminals_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('equipments')}}</span>
                                                            <span class="badge badge-info"> {{parseInt(numberSelectedTerminals) + parseInt(numberSelectedBundlePackages)}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionOne" id="collapse_terminal" :aria-labelledby="`heading_terminal`" class="collapse card-body show">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-12" v-if="isEquipment(bundle_item) && !!bundle_item.display && bundleItemIsSelected(bundle_item)">
                                                                    <equipment-terminals
                                                                        :is-view="true"
                                                                        :bundle="equipment_offer.equipment_list"
                                                                        :bundle_item="bundle_item"
                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-terminals>
                                                                </div>
                                                            </template>
                                                                <div class="col-12">
                                                                    <div
                                                                        v-for="(bundle_package, bundle_package_idx) in equipment_offer.bundle_packages">
                                                                        <div v-if="bundleItemIsSelected(bundle_package)">
                                                                            <equipment-bundles
                                                                                :bundle_package="bundle_package"
                                                                                :is-view="true"
                                                                                :bundle_key="bundle_package_idx">
                                                                            </equipment-bundles>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionTwo" v-if="hasSelectedAccessories">
                                                <div id="accessories" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(accessories_block)"
                                                         :id="`heading_accessories`" data-bs-toggle="collapse" :data-bs-target="`#collapse_accessories`"
                                                         aria-expanded="true" :aria-controls="`collapse_accessories`">
                                                        <h5 class="mb-0">
                                                            <span v-if="accessories_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('equipment_accessories')}}</span>
                                                            <span class="badge badge-info"> {{numberSelectedAccessories}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionTwo" id="collapse_accessories" :aria-labelledby="`heading_accessories`" class="collapse card-body">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-12" v-if="isAccessory(bundle_item) && !!bundle_item.display && bundleItemIsSelected(bundle_item)">
                                                                    <equipment-terminals
                                                                        :is-view="true"
                                                                        :bundle="equipment_offer.equipment_list"
                                                                        :bundle_item="bundle_item"
                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-terminals>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionThree" v-if="hasSelectedServices">
                                                <div id="terminal_services" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(terminal_services_block)"
                                                         :id="`heading_terminal_services`" data-bs-toggle="collapse" :data-bs-target="`#collapse_terminal_services`"
                                                         aria-expanded="true" :aria-controls="`collapse_terminal_services`">
                                                        <h5 class="mb-0">
                                                            <span v-if="terminal_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('equipment_services')}}</span>
                                                            <span class="badge badge-info"> {{numberSelectedServices}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionThree" id="collapse_terminal_services" :aria-labelledby="`heading_terminal_services`" class="collapse card-body">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-12" v-if="isService(bundle_item)  && !!bundle_item.display && bundleItemIsSelected(bundle_item)">
                                                                    <equipment-services :bundle_item="bundle_item"
                                                                                        :is-view="true"
                                                                                        :is-standalone="false"
                                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-services>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionFive" v-if="hasSelectedGeneralServices">
                                                <div id="general_services" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(general_services_block)"
                                                         :id="`heading_general_services`" data-bs-toggle="collapse" :data-bs-target="`#collapse_general_services`"
                                                         aria-expanded="true" :aria-controls="`collapse_general_services`">
                                                        <h5 class="mb-0">
                                                            <span v-if="general_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('general_services')}}</span>
                                                            <span class="badge badge-info"> {{numberSelectedGeneralServices}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionFive" id="collapse_general_services" :aria-labelledby="`heading_general_services`" class="collapse card-body show">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-12" v-if="isGeneralService(bundle_item)  && !!bundle_item.display && bundleItemIsSelected(bundle_item)">
                                                                    <equipment-services
                                                                        :bundle="equipment_offer.equipment_list"
                                                                        :bundle_item="bundle_item"
                                                                        :is-view="true"
                                                                        :is-standalone="false"
                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-services>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="accordionFour" v-if="hasSelectedStandaloneServices">
                                                <div id="standalone_services" class="card">
                                                    <div class="card-header cursorPointer" @click="toggleAccordionSection(standalone_services_block)"
                                                         :id="`heading_standalone_services`" data-bs-toggle="collapse" :data-bs-target="`#collapse_standalone_services`"
                                                         aria-expanded="true" :aria-controls="`collapse_standalone_services`">
                                                        <h5 class="mb-0">
                                                            <span v-if="standalone_services_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                            <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                            <span>{{lang('additional_options')}}</span>
                                                            <span class="badge badge-info"> {{numberSelectedStandaloneServices}} {{lang('selected')}}</span>
                                                        </h5>
                                                    </div>
                                                    <div data-bs-parent="#accordionFour" id="collapse_standalone_services" :aria-labelledby="`heading_standalone_services`" class="collapse card-body show">
                                                        <div class="row">
                                                            <template v-for="(bundle_item, item_idx) in equipment_offer.equipment_list.bundle_items">
                                                                <div class="col-12" v-if="isStandaloneService(bundle_item) && !!bundle_item.display && bundleItemIsSelected(bundle_item)">
                                                                    <equipment-service-pci :bundle_item="bundle_item"
                                                                                           :is-standalone="true"
                                                                                            :is-view="true"
                                                                                           v-if="!!bundle_item.service && bundle_item.service.service_api_code === 'pciInfo'"
                                                                                           :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                           :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-service-pci>
                                                                    <equipment-service-statement :bundle_item="bundle_item"
                                                                                                 :is-standalone="true"
                                                                                                  :is-view="true"
                                                                                                 v-else-if="!!bundle_item.service && statementTypes.hasOwnProperty(bundle_item.service.service_api_code)"
                                                                                                 :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                                 :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-service-statement>
                                                                    <equipment-service-distribution :bundle_item="bundle_item"
                                                                                                    :is-standalone="true"
                                                                                                     :is-view="true"
                                                                                                    v-else-if="!!bundle_item.service && distributionTypes.hasOwnProperty(bundle_item.service.service_api_code)"
                                                                                                    :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                                    :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-service-distribution>
                                                                    <equipment-service-dcc :bundle_item="bundle_item"
                                                                                           :is-standalone="true"
                                                                                            :is-view="true"
                                                                                           v-else-if="!!bundle_item.service && (bundle_item.service.service_api_code === 'dynamicCurrencyConversion')"
                                                                                           :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                           :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-service-dcc>
                                                                    <equipment-services :bundle_item="bundle_item"
                                                                                        v-else
                                                                                        :is-standalone="true"
                                                                                         :is-view="true"
                                                                                        :id="`quote_equipment_offer_equipment_list_bundle_item${item_idx}`"
                                                                                        :name="`quote[equipment_offer][equipment_list][bundle_item][${item_idx}]`">
                                                                    </equipment-services>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="showSection('online_offerings')">
                    <div class="col-lg-6 col-md-12 col-12">
                        <np-entry
                                :label="lang('online_offering')"
                                :formatter="formatOnlineOffering"
                                mode="inline"
                                v-show="online_offerings.length > 1"
                                :value="quote.online_offer.equipment_offering_external_id">
                        </np-entry>
                    </div>
                    <div v-if="online_is_loading" class="col-12">
                        <np-skeleton :type="'equipment'"></np-skeleton>
                    </div>
                    <div v-else class="col-12">
                        <div class="row" v-if="hasSelectedOnlineEquipmentList">
                            <div class="col-12">
                                <div class="panel-sub-heading headingSmall">
                                    <span class="markedBottom">{{lang('online_ecommerce_products')}}</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div id="accordionSevenOnline" v-if="hasOnlineSpecialOffers">
                                    <div id="special_offer_online" class="card">
                                        <div class="card-header cursorPointer" @click="toggleAccordionSection(special_offer_block)"
                                             :id="`heading_special_offer_online`" data-bs-toggle="collapse" :data-bs-target="`#collapse_special_offer_online`"
                                             aria-expanded="true" :aria-controls="`collapse_special_offer_online`">
                                            <h5 class="mb-0">
                                                <span v-if="special_offer_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                <span>{{lang('special_offers')}}</span>
                                                <span class="badge badge-info"
                                                      v-if="numberSelectedOnlineSpecialOfferServices > 0">
                                                    {{numberSelectedOnlineSpecialOfferServices}} {{lang('selected')}}
                                                </span>
                                            </h5>
                                        </div>
                                        <div data-bs-parent="#accordionSevenOnline" id="collapse_special_offer_online"
                                             :aria-labelledby="`heading_special_offer_online`" class="collapse card-body show">
                                            <div class="row">
                                                <template v-for="(bundle_item, item_idx) in online_offer.equipment_list.bundle_items">
                                                    <div class="col-12" v-if="isSpecialOfferService(bundle_item) && bundle_item.display && bundleItemIsSelected(bundle_item)">
                                                        <equipment-services :bundle_item="bundle_item"
                                                                            :is-standalone="false"
                                                                            :is-online="true"
                                                                            :is-view="true"
                                                                            :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                                            :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </equipment-services>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="accordionEightOnline" v-if="hasThirdPartyOnline">
                                    <div id="third_party_online" class="card">
                                        <div class="card-header cursorPointer" @click="toggleAccordionSection(third_party_online_block)"
                                             :id="`heading_third_party_online`" data-bs-toggle="collapse" :data-bs-target="`#collapse_third_party_online`"
                                             aria-expanded="true" :aria-controls="`collapse_third_party_online`">
                                            <h5 class="mb-0">
                                                <span v-if="third_party_online_block.is_open" class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                <span v-else class="caretSign rotate"><i class="fa fa-caret-down"></i></span>
                                                <span>{{lang('third_party_equipments')}}</span>
                                                <span class="badge badge-info" v-if="numberSelectedThirdPartyOnline > 0"> {{numberSelectedThirdPartyOnline}} {{lang('selected')}}</span>
                                            </h5>
                                        </div>
                                        <div data-bs-parent="#accordionEightOnline" id="collapse_third_party_online" :aria-labelledby="`heading_third_party_online`" class="collapse card-body show">
                                            <div class="row">
                                                <template v-for="(bundle_item, item_idx) in online_offer.equipment_list.bundle_items">
                                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12" v-if="isThirdPartyEquipmentService(bundle_item) && bundle_item.display">
                                                        <third-party-equipment
                                                            :bundle_item="bundle_item"
                                                            :is-standalone="false"
                                                            :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                            :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`"
                                                            :isView="true"
                                                        >
                                                        </third-party-equipment>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="accordionOneOnline" v-if="hasSelectedOnlineServices">
                                    <div id="online_services" class="card">
                                        <div class="card-header cursorPointer"
                                             @click="toggleAccordionSection(online_services_block)"
                                             :id="`heading_online_services`" data-bs-toggle="collapse"
                                             :data-bs-target="`#collapse_online_services`"
                                             aria-expanded="true" :aria-controls="`collapse_online_services`">
                                            <h5 class="mb-0">
                                            <span v-if="online_services_block.is_open" class="caretSign rotate"><i
                                                class="fa fa-caret-up"></i></span>
                                                <span v-else class="caretSign rotate"><i
                                                    class="fa fa-caret-down"></i></span>
                                                <span>{{ lang('equipment_services') }}</span>
                                                <span class="badge badge-info"
                                                      v-if="numberSelectedOnlineTerminalServices > 0"> {{
                                                        numberSelectedOnlineTerminalServices
                                                    }} {{ lang('selected') }}</span>
                                            </h5>
                                        </div>
                                        <div data-bs-parent="#accordionOneOnline" id="collapse_online_services"
                                             :aria-labelledby="`heading_online_services`"
                                             class="collapse show card-body">
                                            <div class="row">
                                                <template v-for="(bundle_item, item_idx) in online_offer.equipment_list.bundle_items">
                                                    <div class="col-12" v-if="!!bundle_item.display && isService(bundle_item) && bundleItemIsSelected(bundle_item)">
                                                        <equipment-services :bundle_item="bundle_item"
                                                                            :is-standalone="false"
                                                                            :is-view="true"
                                                                            :is-online="true"
                                                                            :id="`quote_online_offer_bundle_service${item_idx}_selected`"
                                                                            :name="`quote[online_offer][bundle][service][${item_idx}][selected]`">
                                                        </equipment-services>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="accordionTwoOnlineGeneralServices" v-if="hasSelectedOnlineGeneralServices">
                                    <div id="online_general_services" class="card">
                                        <div class="card-header cursorPointer"
                                             @click="toggleAccordionSection(online_general_services_block)"
                                             :id="`heading_online_general_services`" data-bs-toggle="collapse"
                                             :data-bs-target="`#collapse_online_general_services`"
                                             aria-expanded="true"
                                             :aria-controls="`collapse_online_general_services`">
                                            <h5 class="mb-0">
                                              <span v-if="online_general_services_block.is_open"
                                                    class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                <span v-else class="caretSign rotate"><i
                                                    class="fa fa-caret-down"></i></span>
                                                <span>{{ lang('general_services') }}</span>
                                                <span class="badge badge-info"
                                                      v-if="numberSelectedOnlineGeneralServices > 0"> {{
                                                        numberSelectedOnlineGeneralServices
                                                    }} {{ lang('selected') }}</span>
                                            </h5>
                                        </div>
                                        <div data-bs-parent="#accordionTwoOnlineGeneralServices"
                                             id="collapse_online_general_services"
                                             :aria-labelledby="`heading_online_general_services`"
                                             class="collapse card-body">
                                            <div class="row">
                                                <template v-for="(bundle_item, item_idx) in online_offer.equipment_list.bundle_items">
                                                    <div class="col-12" v-if="isGeneralService(bundle_item) && bundle_item.display && bundleItemIsSelected(bundle_item)">
                                                        <equipment-services :bundle_item="bundle_item"
                                                                            :is-standalone="false"
                                                                            :is-online="true"
                                                                            :is-view="true"
                                                                            :id="`quote_online_offer_bundle_service${item_idx}_selected`"
                                                                            :name="`quote[online_offer][bundle][service][${item_idx}][selected]`">
                                                        </equipment-services>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="accordionThreeOnlineStandaloneServices" v-if="hasSelectedOnlineStandaloneServices">
                                    <div id="online_standalone_services" class="card">
                                        <div class="card-header cursorPointer"
                                             @click="toggleAccordionSection(online_standalone_services_block)"
                                             :id="`heading_online_standalone_services`" data-bs-toggle="collapse"
                                             :data-bs-target="`#collapse_online_standalone_services`"
                                             aria-expanded="true"
                                             :aria-controls="`collapse_online_standalone_services`">
                                            <h5 class="mb-0">
                                                <span v-if="online_standalone_services_block.is_open"
                                                      class="caretSign rotate"><i class="fa fa-caret-up"></i></span>
                                                <span v-else class="caretSign rotate"><i
                                                    class="fa fa-caret-down"></i></span>
                                                <span>{{ lang('additional_options') }}</span>
                                                <span class="badge badge-info"
                                                      v-if="numberSelectedOnlineStandaloneServices > 0"> {{numberSelectedOnlineStandaloneServices}} {{ lang('selected') }}</span>
                                            </h5>
                                        </div>
                                        <div data-bs-parent="#accordionThreeOnlineStandaloneServices"
                                             id="collapse_online_standalone_services"
                                             :aria-labelledby="`heading_online_standalone_services`"
                                             class="collapse show card-body">
                                            <div class="row">
                                                <template v-for="(bundle_item, item_idx) in online_offer.equipment_list.bundle_items">
                                                    <div class="col-12" v-if="isStandaloneService(bundle_item) && bundle_item.display && bundleItemIsSelected(bundle_item)">
                                                        <equipment-service-pci :bundle_item="bundle_item"
                                                                               :is-standalone="true"
                                                                               :is-view="true"
                                                                               v-if="!!bundle_item.service && (bundle_item.service.service_api_code === 'pciInfo' || bundle_item.service.service_api_code === 'pciinfo')"
                                                                               :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                                               :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </equipment-service-pci>
                                                        <equipment-service-statement :bundle_item="bundle_item"
                                                                                     :is-standalone="true"
                                                                                     :is-view="true"
                                                                                     v-else-if="!!bundle_item.service && statementTypes.hasOwnProperty(bundle_item.service.service_api_code)"
                                                                                     :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                                                     :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </equipment-service-statement>
                                                        <equipment-service-distribution :bundle_item="bundle_item"
                                                                                        :is-standalone="true"
                                                                                        :is-view="true"
                                                                                        v-else-if="!!bundle_item.service && distributionTypes.hasOwnProperty(bundle_item.service.service_api_code)"
                                                                                        :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                                                        :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </equipment-service-distribution>
                                                        <equipment-service-dcc :bundle_item="bundle_item"
                                                                               :is-standalone="true"
                                                                               :is-view="true"
                                                                               v-else-if="!!bundle_item.service && (bundle_item.service.service_api_code === 'dynamicCurrencyConversion')"
                                                                               :id="`quote_online_offer_equipment_list_bundle_item${item_idx}`"
                                                                               :name="`quote[online_offer][equipment_list][bundle_item][${item_idx}]`">
                                                        </equipment-service-dcc>
                                                        <equipment-services :bundle_item="bundle_item"
                                                                            v-else
                                                                            :is-standalone="true"
                                                                            :is-online="true"
                                                                            :is-view="true"
                                                                            :id="`quote_online_offer_bundle_service${item_idx}_selected`"
                                                                            :name="`quote[online_offer][bundle][service][${item_idx}][selected]`">
                                                        </equipment-services>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row">
            <div class="col-12">
                <np-notice :notice-class="'alert-info'" :notice="lang('select_equipment_offering')"
                           :dismissable="false"
                ></np-notice>
            </div>
        </div>
        <div class="row mt-4" style="border-top: 1px solid #b2c6d0" v-if="!is_reviewing && loading_finished">
            <div class="col-12">
                <div class="my-3">
                    <button type="button" class="btn btn-danger me-1" @click="goBack"> {{lang('go_back')}}</button>
                    <button type="button" class="btn btn-default me-1" @click="doContinue"> {{lang('continue')}}</button>
                </div>
            </div>
        </div>
</div>
</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";

    import {
        NPInput, NPEntry,
        NPRadios, NPResponsive,
        NPSelect2, NPSkeleton,
        NPNotice
    } from "netpify/components";
    import NpMultiselect from "netpify/components/np-multiselect.vue";

    import {mapState} from "vuex";
    import equipmentMixin from "../../../utils/equipment-mixin";
    import EquipmentServices from "../../../components/equipment-services.vue";
    import EquipmentTerminals from "../../../components/equipment-terminals.vue";
    import EquipmentBundles from "../../../components/equipment-bundles.vue";
    import EquipmentServicePci from "../../../components/equipment-service-pci.vue";
    import EquipmentServiceStatement from "../../../components/equipment-service-statement.vue";
    import EquipmentServiceDistribution from "../../../components/equipment-service-distribution.vue";
    import EquipmentServiceDCC from "../../../components/equipment-service-dcc.vue";
    import ThirdPartyTerminals from "../../../components/equipment-service-thirdpartyterminal.vue";
    import TalechService from '../../../components/talech-service.vue';

    export default {
        name: "viewEquipments",
        mixins: [utilMixin, applicationMixin, equipmentMixin],
        components: {
            'np-multiselect': NpMultiselect,
            'np-entry': NPEntry,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-responsive': NPResponsive,
            'np-skeleton': NPSkeleton,
            'np-notice': NPNotice,
            'equipment-services': EquipmentServices,
            'equipment-terminals': EquipmentTerminals,
            'equipment-bundles': EquipmentBundles,
            'equipment-service-pci': EquipmentServicePci,
            'equipment-service-statement': EquipmentServiceStatement,
            'equipment-service-distribution': EquipmentServiceDistribution,
            'equipment-service-dcc': EquipmentServiceDCC,
            'third-party-equipment': ThirdPartyTerminals,
            'talech-service': TalechService,
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        data() {
            return {
                page_label: 'select_your_equipment',
                tinybox_index: null,
                dragging: false,
                equipment_is_loading: true,
                online_is_loading: true,
                statementTypes: {
                    'billingStatement': 'billingStatementType',
                    'fundingStatement': 'fundingStatementType',
                    'electronicStatement': 'electronicStatementType',
                },
                distributionTypes: {
                    'distributions.chargeback': 'distributions.chargeback',
                    'distributions.retrieval': 'distributions.retrieval',
                },
                abortRouteLeave: false,
            }
        },
        metaInfo() {
            return {
                title: this.lang('equipment_selection')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => vm.setAppPageTitle(vm.page_label))
        },
        mounted() {
            this.is_view = true;

            //moved from mixin to avoid multiple calls by  child components loading mixin
            if (!!this.quote.hasOwnProperty('equipment_offer') && !!this.quote.equipment_offer.equipment_offering_external_id) {
                this.getEntityOffer(this.quote.equipment_offer.equipment_offering_external_id)
            }
            if (!!this.quote.hasOwnProperty('online_offer') && !!this.quote.online_offer.equipment_offering_external_id){
                this.getEntityOffer(this.quote.online_offer.equipment_offering_external_id, 'online_offer')
            }
        },
        computed: {
            // terminalListSelected: function () {
            //     let selected = true;
            //
            //     let equipmentSelected = (bundles) => {
            //         return bundles.some(bundle => {
            //             return bundle.bundle_items.some(bundle_item => {
            //                 return bundle_item.selected !== '';
            //             })
            //         })
            //     }
            //
            //     return (this.objectIsNotEmpty(this.quote.equipment_offer.bundles) && equipmentSelected(this.quote.equipment_offer.bundles))
            //         || (this.objectIsNotEmpty(this.quote.online_offer.bundles) && equipmentSelected(this.quote.online_offer.bundles));
            //
            // },
            hasSelectedBundlePackage: function (){
                let vm = this;
                let equipmentSelected = (bundles) => {
                                return bundles.some(bundle => {
                                    return bundle.bundle_items.some(bundle_item => {
                                        return  vm.bundleItemIsSelected(bundle_item);
                                    })
                                })
                            }
                return this.objectIsNotEmpty(this.equipment_offer.bundle_packages) && equipmentSelected(this.equipment_offer.bundle_packages)
            },
            hasSelectedTerminalEquipmentList: function () {
                return this.objectIsNotEmpty(this.equipment_offer.equipment_list) && this.equipment_offer.equipment_list.bundle_items.some(bundle_item => {
                    return bundle_item.display && this.bundleItemIsSelected(bundle_item);
                })
            },
            hasSelectedTerminals: function (){
                let vm = this;
                return this.hasSelectedTerminalEquipmentList
                    && this.equipment_offer.equipment_list.bundle_items.some(item => item.display && vm.isEquipment(item) && vm.bundleItemIsSelected(item))
            },
            hasSelectedAccessories: function () {
                let vm = this;
                return this.hasSelectedTerminalEquipmentList
                    && this.equipment_offer.equipment_list.bundle_items.some(item => item.display && vm.isAccessory(item) && vm.bundleItemIsSelected(item))
            },
            hasSelectedStandaloneServices: function (){
                let vm = this;
                return this.hasSelectedTerminalEquipmentList
                    && this.equipment_offer.equipment_list.bundle_items.some(item => vm.isStandaloneService(item) && item.display && vm.bundleItemIsSelected(item))
            },
            hasSelectedGeneralServices: function (){
                let vm = this;
                return this.hasSelectedTerminalEquipmentList
                    && this.equipment_offer.equipment_list.bundle_items.some(item => vm.isGeneralService(item) && item.display && vm.bundleItemIsSelected(item))
            },
            hasSelectedServices: function(){
                let vm = this;
                return this.hasSelectedTerminalEquipmentList
                    && this.equipment_offer.equipment_list.bundle_items.some(item => vm.isService(item) && item.display && vm.bundleItemIsSelected(item))
            },
            hasSelectedOnlineEquipmentList: function (){
                let vm = this;
                return this.objectIsNotEmpty(this.online_offer.equipment_list)
                    && this.online_offer.equipment_list.bundle_items.some(item => vm.objectIsNotEmpty(item.service) && item.display && vm.bundleItemIsSelected(item))
            },
            hasSelectedOnlineServices: function (){
                let vm = this;
                return this.hasSelectedOnlineEquipmentList
                    && this.online_offer.equipment_list.bundle_items.some(item => vm.isService(item) && item.display && vm.bundleItemIsSelected(item))
            },
            hasSelectedOnlineStandaloneServices: function (){
                let vm = this;
                return this.hasSelectedOnlineEquipmentList
                    && this.online_offer.equipment_list.bundle_items.some(item => vm.isStandaloneService(item) && item.display && vm.bundleItemIsSelected(item))
            },
            hasSelectedOnlineGeneralServices: function (){
                let vm = this;
                return this.hasSelectedOnlineEquipmentList
                    && this.online_offer.equipment_list.bundle_items.some(item => vm.isGeneralService(item) && item.display && vm.bundleItemIsSelected(item))
            },
            loading_finished: function () {
                return (this.showSection('equipment_offerings') && !this.equipment_is_loading)
                    || (this.showSection('online_offerings') && !this.online_is_loading);
            }
        },
        methods: {
            goBack: function (){
                this.abortRouteLeave = true;
                this.$router.push({path:  this.quote_root_path +'business/'})
            },
            doContinue: function (){
                let vm = this;
                let path_to = this.quote_root_path + 'business/pricing/';
                if (this.inQuoteViewMode){
                    // this.nextPage();
                    this.$router.push({path: path_to})
                }else {
                    vm.$router.push({path: path_to})
                }
            },
            showSection: function (section = 'equipment_offerings') {
                if (section === 'equipment_offerings') {
                    return !!this.quote && this.objectIsNotEmpty(this.quote.equipment_offer)
                        && !!this.quote.equipment_offer.equipment_offering_external_id
                        && this.quote.equipment_offer.equipment_offering_external_id !=='';
                }

                //online
                return !!this.quote && this.objectIsNotEmpty(this.quote.online_offer)
                    && !!this.quote.online_offer.equipment_offering_external_id
                    && this.quote.online_offer.equipment_offering_external_id !=='';
            },
            // viewItemIsSelected: function (bundle_item){
            //     return bundle_item.is_boarding_activated === '1';
            //     // return (bundle_item.selected == '1' || !!bundle_item.selected) && bundle_item.selected !== '' && bundle_item.selected != '0';
            // }
        },
        watch: {
            "quote.package_external_id": {
                immediate: true,
                handler: function(val, oldVal) {

                    if (!!val && (this.quote.payment_method !== this.payment_method.PAYMENT_METHOD_ECOM_ONLY && !this.objectIsNotEmpty(this.equipment_offer))) {
                        this.setOfferings(val);
                    }
                    //online
                    if (!!val && (this.quote.payment_method !== this.payment_method.PAYMENT_METHOD_F2F_ONLY && !this.objectIsNotEmpty(this.online_offer))) {
                        this.setOfferings(val);
                    }
                }
            },
        }
    }
</script>

<style scoped>
    ul:not(.nav-pills) {
        list-style: none;
    }

    li:not(.nav-item) {
        font-weight: lighter;
        font-size: 0.8em;
    }

    li:not(.nav-item):before {
        content: "\f054"; /* FontAwesome Unicode fa-chevron-right*/
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        display: inline-block;
        margin-left: -1.3em; /* same as padding-left set on li */
        width: 1.3em; /* same as padding-left set on li */
    }

    img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 100%;
        height: auto
    }

    .avatar-small {
        width: 100px;
        border-radius: 6px;
        display: block;
        padding: 2px;
        margin: 10px auto;
    }

    /*.avatar-small:hover {*/
    /*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/
    /*    -ms-transform: scale(2.5); !* IE 9 *!*/
    /*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/
    /*    transform: scale(2.5);*/
    /*    cursor: pointer;*/
    /*    z-index: 99999;*/
    /*}*/

    .card-header .badge {
        float: right;
    }

</style>
